var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Applicants',_vm._g(_vm._b({},'Applicants',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }